import AxiosInstance from "./api";

export const ProjectCostLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/project-cost-ledger/paginate", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/project-cost-ledger/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/project-cost-ledger/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/project-cost-ledger", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/project-cost-ledger/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/project-cost-ledger/" + id);
  },
};
